'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var debug = require('debug');

var log = Object.assign(debug('libp2p:peer-routing'), {
  error: debug('libp2p:peer-routing:err')
});

var errCode = require('err-code');

var _require = require('./content-routing/utils'),
    storeAddresses = _require.storeAddresses,
    uniquePeers = _require.uniquePeers,
    requirePeers = _require.requirePeers;

var merge = require('it-merge');

var _require2 = require('it-pipe'),
    pipe = _require2.pipe;

var first = require('it-first');

var drain = require('it-drain');

var filter = require('it-filter');

var _require3 = require('set-delayed-interval'),
    setDelayedInterval = _require3.setDelayedInterval,
    clearDelayedInterval = _require3.clearDelayedInterval;
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 * @typedef {import('libp2p-interfaces/src/peer-routing/types').PeerRouting} PeerRoutingModule
 */

/**
 * @typedef {Object} RefreshManagerOptions
 * @property {boolean} [enabled = true] - Whether to enable the Refresh manager
 * @property {number} [bootDelay = 6e5] - Boot delay to start the Refresh Manager (in ms)
 * @property {number} [interval = 10e3] - Interval between each Refresh Manager run (in ms)
 *
 * @typedef {Object} PeerRoutingOptions
 * @property {RefreshManagerOptions} [refreshManager]
 */


var PeerRouting = /*#__PURE__*/function () {
  /**
   * @class
   * @param {import('./')} libp2p
   */
  function PeerRouting(libp2p) {
    _classCallCheck(this, PeerRouting);

    this._peerId = libp2p.peerId;
    this._peerStore = libp2p.peerStore;
    /** @type {PeerRoutingModule[]} */

    this._routers = libp2p._modules.peerRouting || []; // If we have the dht, add it to the available peer routers

    if (libp2p._dht && libp2p._config.dht.enabled) {
      this._routers.push(libp2p._dht);
    }

    this._refreshManagerOptions = libp2p._options.peerRouting.refreshManager;
    this._findClosestPeersTask = this._findClosestPeersTask.bind(this);
  }
  /**
   * Start peer routing service.
   */


  _createClass(PeerRouting, [{
    key: "start",
    value: function start() {
      if (!this._routers.length || this._timeoutId || !this._refreshManagerOptions.enabled) {
        return;
      }

      this._timeoutId = setDelayedInterval(this._findClosestPeersTask, this._refreshManagerOptions.interval, this._refreshManagerOptions.bootDelay);
    }
    /**
     * Recurrent task to find closest peers and add their addresses to the Address Book.
     */

  }, {
    key: "_findClosestPeersTask",
    value: function () {
      var _findClosestPeersTask2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return drain(this.getClosestPeers(this._peerId.id));

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                log.error(_context.t0);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function _findClosestPeersTask() {
        return _findClosestPeersTask2.apply(this, arguments);
      }

      return _findClosestPeersTask;
    }()
    /**
     * Stop peer routing service.
     */

  }, {
    key: "stop",
    value: function stop() {
      clearDelayedInterval(this._timeoutId);
    }
    /**
     * Iterates over all peer routers in parallel to find the given peer.
     *
     * @param {PeerId} id - The id of the peer to find
     * @param {object} [options]
     * @param {number} [options.timeout] - How long the query should run
     * @returns {Promise<{ id: PeerId, multiaddrs: Multiaddr[] }>}
     */

  }, {
    key: "findPeer",
    value: function () {
      var _findPeer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, options) {
        var _this2 = this;

        var output;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this._routers.length) {
                  _context2.next = 2;
                  break;
                }

                throw errCode(new Error('No peer routers available'), 'NO_ROUTERS_AVAILABLE');

              case 2:
                if (!(id.toB58String() === this._peerId.toB58String())) {
                  _context2.next = 4;
                  break;
                }

                throw errCode(new Error('Should not try to find self'), 'ERR_FIND_SELF');

              case 4:
                _context2.next = 6;
                return pipe(merge.apply(void 0, _toConsumableArray(this._routers.map(function (router) {
                  return [router.findPeer(id, options)];
                }))), function (source) {
                  return filter(source, Boolean);
                }, // @ts-ignore findPeer resolves a Promise
                function (source) {
                  return storeAddresses(source, _this2._peerStore);
                }, function (source) {
                  return first(source);
                });

              case 6:
                output = _context2.sent;

                if (!output) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", output);

              case 9:
                throw errCode(new Error('not found'), 'NOT_FOUND');

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function findPeer(_x, _x2) {
        return _findPeer.apply(this, arguments);
      }

      return findPeer;
    }()
    /**
     * Attempt to find the closest peers on the network to the given key.
     *
     * @param {Uint8Array} key - A CID like key
     * @param {Object} [options]
     * @param {number} [options.timeout=30e3] - How long the query can take.
     * @returns {AsyncIterable<{ id: PeerId, multiaddrs: Multiaddr[] }>}
     */

  }, {
    key: "getClosestPeers",
    value: function getClosestPeers(key) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        timeout: 30e3
      };
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this._routers.length) {
                  _context3.next = 2;
                  break;
                }

                throw errCode(new Error('No peer routers available'), 'NO_ROUTERS_AVAILABLE');

              case 2:
                return _context3.delegateYield(_asyncGeneratorDelegate(_asyncIterator(pipe(merge.apply(void 0, _toConsumableArray(_this._routers.map(function (router) {
                  return router.getClosestPeers(key, options);
                }))), function (source) {
                  return storeAddresses(source, _this._peerStore);
                }, function (source) {
                  return uniquePeers(source);
                }, function (source) {
                  return requirePeers(source);
                })), _awaitAsyncGenerator), "t0", 3);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }]);

  return PeerRouting;
}();

module.exports = PeerRouting;